module.exports = __webpack_public_path__ + "img/tokyo_calender_content2.7fd51338.png";